import { render, staticRenderFns } from "./initial.vue?vue&type=template&id=4b1d2658&scoped=true&"
var script = {}
import style0 from "./initial.vue?vue&type=style&index=0&id=4b1d2658&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1d2658",
  null
  
)

export default component.exports